import React from 'react';
import classnames from 'classnames';
const OffContent = ({ isOn = false, children }) => (<div className={classnames({ hidden: isOn })}>{children}</div>);
export default OffContent;
